import { Container, Grid } from '@chakra-ui/react';
import { formatISO } from 'date-fns';
import { useState } from 'react';

import { CreatePasswordStep } from '@/components/SignUpFlow/CreatePasswordStep';
import { FailureStep } from '@/components/SignUpFlow/FailureStep';
import { Interests } from '@/components/SignUpFlow/Inerests';
import { SuccessStep } from '@/components/SignUpFlow/SuccessStep';
import { UserInfoStep } from '@/components/SignUpFlow/UserInfoStep';
import { PreviousStep } from '@/containers/SignUp/components/PreviousStep';
import { ISignupStepsProps, SignUpContext, SignUpSteps } from '@/containers/SignUp/components/SignUpContext';
import { useAnalytics } from '@/context/Analytics';
import { useStores } from '@/hooks/useStores';
import { User } from '@/resources/User';

interface IRegisterErrorResponse {
  error: Array<{ detail: string }>;
}

export const SignUpFlow = () => {
  const analytics = useAnalytics();
  const { store } = useStores();
  const [currentStep, setCurrentStep] = useState(SignUpSteps.BASIC_INFO);
  const [signUpProps, setSignUpProps] = useState<Partial<ISignupStepsProps>>({ interests: [] });
  const [serverErrors, setServerErrors] = useState([]);

  const triggerRegister = async (passwordData: Partial<ISignupStepsProps>) => {
    const data = {
      data: {
        type: 'registration',
        id: '',
        attributes: {
          ...signUpProps,
          ...passwordData,
          termsAcceptedAt: formatISO(Date.now()),
        },
      },
    };

    try {
      setServerErrors([]);
      const user = await store.request('registration', 'POST', data);

      analytics.track('user_register');
      analytics.identify(user.data as User);

      setCurrentStep(SignUpSteps.FINISH);
    } catch (response) {
      const res: IRegisterErrorResponse = response;

      const resErrors = res.error.map((message) => message.detail);

      setServerErrors(resErrors);
    }
  };

  return (
    <SignUpContext.Provider value={{ setSignUpProps, signUpProps, currentStep, setCurrentStep }}>
      <Container>
        <PreviousStep />
        <Grid my={{ base: 10, lg: '140px' }} placeItems="center">
          {currentStep === SignUpSteps.BASIC_INFO && <UserInfoStep />}
          {currentStep === SignUpSteps.INTERESTS && <Interests />}
          {currentStep === SignUpSteps.CREATE_PASSWORD && <CreatePasswordStep onSubmit={triggerRegister} />}
          {currentStep === SignUpSteps.FINISH && serverErrors.length === 0 && <SuccessStep />}
          {currentStep === SignUpSteps.FINISH && serverErrors.length > 0 && <FailureStep />}
        </Grid>
      </Container>
    </SignUpContext.Provider>
  );
};
